import {useInternationalization} from '@progress/kendo-react-intl'
import moment from 'moment'
import { parse, format } from 'date-fns';

const SQL_DATE_FORMAT = 'yyyyMMdd hh:mm:ss'
const mappings: any = {
  eq: "{0} = '{1}'",
  neq: "{0} != '{1}'",
  isnull: '{0} IS NULL',
  isnotnull: '{0} IS NOT NULL',
  lt: "{0} < '{1}'",
  lte: "{0} <= '{1}'",
  gt: "{0} > '{1}'",
  gte: "{0} >= '{1}'",
  startswith: "{0} LIKE '{1}%'",
  doesnotstartwith: "{0} NOT LIKE '{1}%'",
  contains: "{0} LIKE '%{1}%'",
  doesnotcontain: "{0} NOT LIKE '%{1}%'",
  isempty: "{0} = ''",
  isnotempty: "{0} != ''",
}

export const toSQLExpression = (filter: any) => {
  if (!filter) return
  var {filters} = filter
  var result = ''
  for (let i = 0; i < filters.length; i++) {
    if (i !== 0) {
      result += ` ${filter.logic} `
    }

    var {operator, field, value} = filters[i]
    var mapping = mappings[operator]
    let type: typeof value

    if (type === 'date') {
      value = value.toString(value, SQL_DATE_FORMAT)
    }
    var query = mapping.replace('{0}', field).replace('{1}', value)
    result += query
  }

  return result
}

export const toObjectExpression = (filter: any) => {
  var data: any = {}
  ;((filter != null && filter.filters) || []).forEach((filter: any) => {
    var {field, value} = filter
    data[field] = value
  })
  return data
}

export const toLinQExpression = (filter: any) => {
  let data: any = ''
  ;((filter !== null && filter.filters) || []).forEach((filter: any, index: number) => {
    if (index > 0) data += ' and '
    var {field, value, type} = filter

    if (typeof 0 === type) {
      data += `${field} = (${value})`
    } else if (typeof true === type) {
      if (field === 'InActive') {
        data += `${field}.equals(${value !== 'Active'} || ${value === 'Delivered'})`
      } else data += `${field}.equals(${value === 'Active'} || ${value === 'Delivered'})`
    } else if (typeof new Date() === type) {
      if (value) {
        const newValue = dateFormat(value)
        data += `${field} = DateTime.ParseExact("${newValue}", "dd/MM/yyyy", null)`
      }
    } else data += `${field}.contains("${value}")`
  })
  return data
}

// mm/dd/yyyy date args
export const dateFormat = (date: any) => {
  if (!date) return null
  date = new Date(date)
  return moment(date).format('DD/MM/YYYY')
}

// dd/mm/yyyy to dates
export const dateFormatDDMMYYY = (dateString: any) => {
  if (!dateString) return null
  var dateParts = dateString.split('/')

  return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]).setSeconds(1)
}

export const formatDateWithTime = (date: any) => {
  if (!date) return null;
  date = new Date(date);
  return moment(date).format('DD-MMM-YYYY hh:mm a');
}

export const formatDateWithTimeFromString = (dateString: string): string => {
  if (!dateString) return '';
  const parsedDate = parse(dateString, 'dd/MM/yyyy hh:mm:ss a', new Date());
  return format(parsedDate, 'dd-MMM-yyyy hh:mm a');
}

export const getDateOffset = (date: Date) => {
  const offset = date.getTimezoneOffset();
  date = new Date(date.getTime() - (offset * 60 * 1000));

  return date;
}

export const validateDate = (date: Date) => {
  if (!moment(date).isValid()) return false

  if (date.getFullYear() < 1900) return false

  return true
}

export const CurrencyFormatter = (value: number) => {
  const intl = useInternationalization()
  if (!value) return intl.formatNumber(0, 'c')

  return intl.formatNumber(value, 'c')
}

export const userCanEdit = (roles?: string[]) => {
  const data = (roles || ['']).find((role: string) => role === 'Administrator')
  return data !== undefined
}

export const unique = (value: any, index: any, self: any) => {
  return self.indexOf(self.find((t: any) => t.clientId === value.clientId)) === index
}
export const filterToObject = (filter: any) => {
  var data = {}
  ;((filter !== null && filter.filters) || []).forEach((filter: any) => {
    var {field, value} = filter
    if (value)
      data = {
        ...data,
        [field]: value,
      }
  })
  return data
}

export const resolveMessage = (error: any, fallbackMessage: string) =>
    error?.response?.data?.message || error?.message || fallbackMessage;

// export const getBase64 = () => {
//     const link = 'C:/C9_Project/BES/src/client/public/images/andrew_sig.png'
//     let canvas = document.createElement('canvas');
//     let context = canvas.getContext('2d');
//     let img = document.querySelector('img');
//     context.drawImage(img, 0, 0);

//     let reader = new Blob(link)
// }
